import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EThemeMode, EThemes, ThemeState } from './types'

const initialState: ThemeState = {
  initialTheme: EThemes.light,
  mode: EThemeMode.new,
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<EThemes>) => {
      state.selected = action.payload
    },
    toggleTheme: (state) => {
      state.selected = state.selected === EThemes.light ? EThemes.dark : EThemes.light
    },
    setInitialTheme: (state, action: PayloadAction<ThemeState['initialTheme']>) => {
      state.initialTheme = action.payload
    },
    toggleMode: (state) => {
      state.mode = state.mode === EThemeMode.old ? EThemeMode.new : EThemeMode.old
    },
  },
})

export const { setTheme, toggleTheme, setInitialTheme, toggleMode } = themeSlice.actions

export default themeSlice
